import { j as l } from "./AccesRecoveryIcon-CUPieIxT.js";
const a = () => /* @__PURE__ */ l.jsxs("svg", { viewBox: "0 0 402 402", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ l.jsx(
    "path",
    {
      d: "m191.468 186.614-93.573 97.585h34.112L201 215.21l68.994 68.989h34.112l-93.573-97.585a13.47 13.47 0 0 0-9.533-3.95 13.48 13.48 0 0 0-9.532 3.95",
      fill: "#fff"
    }
  ),
  /* @__PURE__ */ l.jsx(
    "path",
    {
      d: "M201.001.031C90.008.031.031 90.008.031 201.001S90.008 401.97 201.001 401.97 401.97 311.993 401.97 201.001C401.97 90.008 311.993.031 201.001.031m0 378.16a177.191 177.191 0 1 1 0-354.382 177.191 177.191 0 0 1 0 354.382",
      fill: "#FCA311"
    }
  ),
  /* @__PURE__ */ l.jsx(
    "path",
    {
      d: "M201.19 24A177.19 177.19 0 0 0 37.488 133.382a177.192 177.192 0 0 0 231.51 231.511 177.192 177.192 0 0 0 0-327.405A177.2 177.2 0 0 0 201.19 24m-78.934 93.991h79.711c53.138 0 85.258 27.279 85.258 72.351 0 16.98-4.72 31.365-13.307 42.768l-21.214-19.953a48.36 48.36 0 0 0 5.324-22.815c0-29.65-19.565-46.555-56.939-46.555h-49.635v60.541l-29.198 31.052zM270.184 284.39l-68.994-68.989-68.993 68.989H98.084l93.574-97.585a13.48 13.48 0 0 1 9.532-3.95 13.5 13.5 0 0 1 9.533 3.95l93.573 97.585z",
      fill: "#293963"
    }
  ),
  /* @__PURE__ */ l.jsx(
    "path",
    {
      d: "M151.264 143.597H200.9c37.373 0 56.938 16.905 56.938 46.555a48.4 48.4 0 0 1-5.323 22.815l21.214 19.953c8.587-11.403 13.307-25.788 13.307-42.768 0-45.071-32.121-72.351-85.259-72.351h-79.711V235.19l29.198-31.051z",
      fill: "#fff"
    }
  ),
  /* @__PURE__ */ l.jsx("path", { d: "M177.5 284.5 135 240h-33.5l42 44.5z", fill: "#FCA311" })
] });
export {
  a as X
};
